import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#071A14] py-4 px-3 border-b border-[#1F3D2B]" data-id="element-54">
      <div className="max-w-xl mx-auto" data-id="element-55">
        <div className="bg-[#102A1F] border border-[#D4A843] rounded-xl p-3 flex items-center justify-center gap-3 shadow-sm" data-id="element-56">
          <ShieldCheckIcon className="w-8 h-8 text-[#D4A843] flex-shrink-0" strokeWidth={2.5} data-id="element-57" />
          <h3 className="font-black text-[#FFFFFF] text-sm md:text-base uppercase leading-tight" data-id="element-58">
            Garantía de 7 días sin preguntas
          </h3>
        </div>
      </div>
    </section>;
}